var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasicImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 65,
    viewBox: "0 0 102 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.5235 0H6.47628C2.89981 0 0 2.37575 0 5.30607V59.6941C0 62.6242 2.89981 65 6.47628 65H95.5235C99.1002 65 102 62.6242 102 59.6939V5.30607C102 2.37575 99.1004 0 95.5235 0ZM95.5235 5.30607V43.8962L82.7606 34.3889C80.8423 32.9603 77.8923 33.0173 76.0595 34.5203L63.1425 45.102L37.6736 20.1764C35.7485 18.2927 32.2222 18.2742 30.2681 20.1353L6.47628 42.7899V5.30607H95.5235ZM68.0001 19.2347C68.0001 15.2046 71.9858 11.9387 76.9045 11.9387C81.8234 11.9387 85.8093 15.2046 85.8093 19.2347C85.8093 23.2647 81.8236 26.5305 76.9045 26.5305C71.986 26.5307 68.0001 23.2647 68.0001 19.2347Z",
    fill: "#E2E2E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicImg);
export default __webpack_public_path__ + "static/media/basicImg.5023b7b0936707bfd8b13d498163add4.svg";
export { ForwardRef as ReactComponent };